// Parcel's `--public-url ./` already resolves every bundled asset relative to wherever the bundle
// is served from. CSS and icons opted out of that by being built from a host map keyed on
// window.location.host, so they break the moment the bundle moves to a custom-domain subpath --
// the map misses and falls through to a hardcoded (and wrong-environment) CDN. Reading the
// bundle's own URL puts them back on the same mechanism, so one artifact is correct at any prefix.
//
// The Vite loader is the authoritative source. It computes the dist root from its own src and
// then appends the hashed app script, which Vite emits to <root>/static/js/. Reading
// document.currentScript from inside that app script therefore yields <root>/static/js, one level
// too deep, and every icon and stylesheet URL built from it 404s -- on the normal CDN as much as
// on a custom domain. So prefer the value the loader published.
//
// The key is per-app on purpose: swlite can mount casa-web and lead-360 on the same page from
// different prefixes, and a shared global would leave whichever loaded second resolving its
// assets against the other's base.
const LOADER_BASE_KEY = "__CASA_WEB_BUNDLE_BASE__";

const stripTrailingSlash = (url) => String(url).replace(/\/$/, "");

const loaderBase =
  typeof window !== "undefined" ? window[LOADER_BASE_KEY] : undefined;

// Fallback for the legacy Parcel entry, which sits at the dist root, so its own URL is the base.
// document.currentScript is read at module scope on purpose: it is only populated while the
// classic script is executing synchronously, which is exactly when this module body runs.
// import.meta.url is NOT an alternative here -- Parcel compiles it to a build-time literal
// ("file:///src/entry.js"), which would silently produce broken URLs rather than failing loudly.
// The /static/js strip only matters if the Vite bundle is ever loaded without its loader.
const script = typeof document !== "undefined" ? document.currentScript : null;

const scriptBase = script
  ? stripTrailingSlash(new URL(".", script.src).href).replace(/\/static\/js$/, "")
  : "";

export const BUNDLE_BASE = loaderBase ? stripTrailingSlash(loaderBase) : scriptBase;
